(function () {

  let pinnedParent = null;
  let closeTimer = null;


  /* =========================================================
     HELPERS
  ========================================================= */

  function getAllParents() {
    return document.querySelectorAll('[data-ls8-top-menu]');
  }


  function getPanel(parent) {

    if (!parent) {
      return null;
    }

    return (
      parent.querySelector('[data-ls8-mega-menu]') ||
      parent.querySelector('[data-ls8-about-mega-menu]')
    );

  }


  function getPinButton(parent) {

    if (!parent) {
      return null;
    }

    return parent.querySelector('[data-ls8-menu-pin]');

  }


  function clearCloseTimer() {

    if (closeTimer) {

      clearTimeout(closeTimer);

      closeTimer = null;

    }

  }


  function updateAria(parent, isOpen, isPinned) {

    const panel = getPanel(parent);

    const pinButton = getPinButton(parent);


    if (panel) {

      panel.setAttribute(
        'aria-hidden',
        isOpen ? 'false' : 'true'
      );

    }


    if (pinButton) {

      pinButton.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );

      pinButton.setAttribute(
        'aria-pressed',
        isPinned ? 'true' : 'false'
      );

    }

  }



  /* =========================================================
     CLOSE ONE MENU
  ========================================================= */

  function closeParent(parent) {

    if (!parent) {
      return;
    }


    if (parent === pinnedParent) {
      return;
    }


    parent.classList.remove(
      'is-open'
    );


    updateAria(
      parent,
      false,
      false
    );

  }



  /* =========================================================
     CLOSE OTHER MENUS
  ========================================================= */

  function closeOtherParents(exceptParent) {

    getAllParents().forEach(function (parent) {

      if (parent === exceptParent) {
        return;
      }


      if (parent === pinnedParent) {
        return;
      }


      parent.classList.remove(
        'is-open'
      );


      updateAria(
        parent,
        false,
        false
      );

    });

  }



  /* =========================================================
     OPEN HOVER PREVIEW
  ========================================================= */

  function openPreview(parent) {

    clearCloseTimer();


    if (
      pinnedParent &&
      pinnedParent !== parent
    ) {

      return;

    }


    closeOtherParents(parent);


    parent.classList.add(
      'is-open'
    );


    updateAria(
      parent,
      true,
      parent === pinnedParent
    );

  }



  /* =========================================================
     DELAYED HOVER CLOSE
  ========================================================= */

  function closePreviewLater(parent) {

    clearCloseTimer();


    if (parent === pinnedParent) {
      return;
    }


    closeTimer = setTimeout(function () {

      if (parent === pinnedParent) {
        return;
      }


      parent.classList.remove(
        'is-open'
      );


      updateAria(
        parent,
        false,
        false
      );

    }, 260);

  }



  /* =========================================================
     UNPIN CURRENT MENU
  ========================================================= */

  function unpinCurrentMenu(closeMenu) {

    clearCloseTimer();


    if (!pinnedParent) {

      document.body.classList.remove(
        'ls8-menu-lock-active'
      );

      return;

    }


    const oldPinnedParent =
      pinnedParent;


    const pinButton =
      getPinButton(
        oldPinnedParent
      );


    oldPinnedParent.classList.remove(
      'is-pinned'
    );


    if (pinButton) {

      pinButton.classList.remove(
        'is-pinned'
      );


      pinButton.setAttribute(
        'aria-pressed',
        'false'
      );

    }


    pinnedParent = null;


    document.body.classList.remove(
      'ls8-menu-lock-active'
    );


    if (closeMenu !== false) {

      oldPinnedParent.classList.remove(
        'is-open'
      );


      updateAria(
        oldPinnedParent,
        false,
        false
      );

    } else {

      updateAria(
        oldPinnedParent,
        oldPinnedParent.classList.contains(
          'is-open'
        ),
        false
      );

    }

  }



  /* =========================================================
     PIN MENU
  ========================================================= */

  function pinMenu(parent) {

    if (!parent) {
      return;
    }


    clearCloseTimer();


    /*
      Clicking same pin again:
      unpin + close
    */

    if (pinnedParent === parent) {

      unpinCurrentMenu(true);

      return;

    }


    /*
      If another menu is pinned,
      close it first
    */

    if (pinnedParent) {

      const previousPinned =
        pinnedParent;


      const previousButton =
        getPinButton(
          previousPinned
        );


      previousPinned.classList.remove(
        'is-pinned',
        'is-open'
      );


      if (previousButton) {

        previousButton.classList.remove(
          'is-pinned'
        );


        previousButton.setAttribute(
          'aria-expanded',
          'false'
        );


        previousButton.setAttribute(
          'aria-pressed',
          'false'
        );

      }


      updateAria(
        previousPinned,
        false,
        false
      );

    }


    closeOtherParents(parent);


    pinnedParent = parent;


    parent.classList.add(
      'is-open',
      'is-pinned'
    );


    const pinButton =
      getPinButton(parent);


    if (pinButton) {

      pinButton.classList.add(
        'is-pinned'
      );

    }


    document.body.classList.add(
      'ls8-menu-lock-active'
    );


    updateAria(
      parent,
      true,
      true
    );

  }



  /* =========================================================
     INIT TOP LEVEL MENUS
  ========================================================= */

  function initTopLevelMenus(root) {

    const scope =
      root || document;


    const parents =
      scope.querySelectorAll(
        '[data-ls8-top-menu]'
      );


    parents.forEach(function (parent) {


      /*
        Prevent duplicate initialization
      */

      if (
        parent.dataset.ls8TopReady === 'true'
      ) {

        return;

      }


      parent.dataset.ls8TopReady =
        'true';


      const pinButton =
        getPinButton(parent);


      const panel =
        getPanel(parent);



      /* -----------------------------------------
         PARENT HOVER
      ------------------------------------------ */

      parent.addEventListener(
        'mouseenter',
        function () {

          if (
            pinnedParent &&
            pinnedParent !== parent
          ) {

            return;

          }


          openPreview(parent);

        }
      );


      parent.addEventListener(
        'mouseleave',
        function () {

          closePreviewLater(parent);

        }
      );



      /* -----------------------------------------
         MEGA PANEL HOVER
      ------------------------------------------ */

      if (panel) {

        panel.addEventListener(
          'mouseenter',
          function () {

            clearCloseTimer();


            if (
              pinnedParent &&
              pinnedParent !== parent
            ) {

              return;

            }


            parent.classList.add(
              'is-open'
            );


            updateAria(
              parent,
              true,
              parent === pinnedParent
            );

          }
        );


        panel.addEventListener(
          'mouseleave',
          function () {

            closePreviewLater(parent);

          }
        );

      }



      /* -----------------------------------------
         PIN BUTTON CLICK
      ------------------------------------------ */

      if (pinButton) {

        pinButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopPropagation();


            pinMenu(parent);

          }
        );

      }



      /* -----------------------------------------
         KEYBOARD FOCUS
      ------------------------------------------ */

      parent.addEventListener(
        'focusin',
        function () {

          if (
            pinnedParent &&
            pinnedParent !== parent
          ) {

            return;

          }


          openPreview(parent);

        }
      );


      parent.addEventListener(
        'focusout',
        function (event) {

          if (
            parent === pinnedParent
          ) {

            return;

          }


          const nextTarget =
            event.relatedTarget;


          if (
            nextTarget &&
            parent.contains(
              nextTarget
            )
          ) {

            return;

          }


          closePreviewLater(parent);

        }
      );

    });

  }



  /* =========================================================
     INIT 3 LEVEL PRODUCT MEGA MENU
  ========================================================= */

  function initLS8MegaMenu(root) {

    const scope =
      root || document;


    const menus =
      scope.querySelectorAll(
        '[data-ls8-mega-menu]'
      );


    menus.forEach(function (menu) {


      /*
        Prevent duplicate initialization
      */

      if (
        menu.dataset.ls8Ready === 'true'
      ) {

        return;

      }


      menu.dataset.ls8Ready =
        'true';



      const categories =
        menu.querySelectorAll(
          '[data-ls8-category]'
        );


      const seriesPanels =
        menu.querySelectorAll(
          '[data-ls8-series-panel]'
        );


      const seriesItems =
        menu.querySelectorAll(
          '[data-ls8-series]'
        );


      const productPanels =
        menu.querySelectorAll(
          '[data-ls8-product-panel]'
        );



      /* =====================================================
         CLEAR CATEGORIES
      ====================================================== */

      function clearCategories() {

        categories.forEach(
          function (item) {

            item.classList.remove(
              'is-active'
            );

          }
        );

      }



      /* =====================================================
         CLEAR SERIES PANELS
      ====================================================== */

      function clearSeriesPanels() {

        seriesPanels.forEach(
          function (panel) {

            panel.classList.remove(
              'is-active'
            );

          }
        );

      }



      /* =====================================================
         CLEAR SERIES ITEMS
      ====================================================== */

      function clearSeriesItems() {

        seriesItems.forEach(
          function (item) {

            item.classList.remove(
              'is-active'
            );

          }
        );

      }



      /* =====================================================
         CLEAR PRODUCT PANELS
      ====================================================== */

      function clearProductPanels() {

        productPanels.forEach(
          function (panel) {

            panel.classList.remove(
              'is-active'
            );

          }
        );

      }



      /* =====================================================
         ACTIVATE CATEGORY
      ====================================================== */

      function activateCategory(target) {

        clearCategories();

        clearSeriesPanels();

        clearSeriesItems();

        clearProductPanels();


        const category =
          menu.querySelector(
            '[data-ls8-category="' +
            target +
            '"]'
          );


        const panel =
          menu.querySelector(
            '[data-ls8-series-panel="' +
            target +
            '"]'
          );


        if (category) {

          category.classList.add(
            'is-active'
          );

        }


        if (!panel) {

          return;

        }


        panel.classList.add(
          'is-active'
        );


        /*
          Automatically activate
          the first Series
        */

        const firstSeries =
          panel.querySelector(
            '[data-ls8-series]'
          );


        if (!firstSeries) {

          return;

        }


        firstSeries.classList.add(
          'is-active'
        );


        const firstSeriesTarget =
          firstSeries.getAttribute(
            'data-ls8-series'
          );


        const firstProductPanel =
          menu.querySelector(
            '[data-ls8-product-panel="' +
            firstSeriesTarget +
            '"]'
          );


        if (firstProductPanel) {

          firstProductPanel.classList.add(
            'is-active'
          );

        }

      }



      /* =====================================================
         CATEGORY EVENTS
      ====================================================== */

      categories.forEach(
        function (category) {


          function switchCategory() {

            const target =
              category.getAttribute(
                'data-ls8-category'
              );


            if (target) {

              activateCategory(
                target
              );

            }

          }


          /*
            Hover category
          */

          category.addEventListener(
            'mouseenter',
            switchCategory
          );


          /*
            Keyboard focus
          */

          category.addEventListener(
            'focus',
            switchCategory
          );

        }
      );



      /* =====================================================
         ACTIVATE SERIES
      ====================================================== */

      function activateSeries(target) {

        clearSeriesItems();

        clearProductPanels();


        const item =
          menu.querySelector(
            '[data-ls8-series="' +
            target +
            '"]'
          );


        const panel =
          menu.querySelector(
            '[data-ls8-product-panel="' +
            target +
            '"]'
          );


        if (item) {

          item.classList.add(
            'is-active'
          );

        }


        if (panel) {

          panel.classList.add(
            'is-active'
          );

        }

      }



      /* =====================================================
         SERIES EVENTS

         IMPORTANT:

         Hover only controls preview.

         Click is NOT handled here.

         Because the Series item itself
         is a normal <a href=""> link.

         Therefore:

         Hover = preview
         Click = Collection page
      ====================================================== */

      seriesItems.forEach(
        function (item) {


          function switchSeries() {

            const target =
              item.getAttribute(
                'data-ls8-series'
              );


            if (target) {

              activateSeries(
                target
              );

            }

          }


          /*
            Hover Series
            → Change right product preview
          */

          item.addEventListener(
            'mouseenter',
            switchSeries
          );


          /*
            Keyboard focus
            → Change right product preview
          */

          item.addEventListener(
            'focus',
            switchSeries
          );


          /*
            IMPORTANT:

            NO click event here.

            This allows the normal
            <a href=""> behavior.

            Clicking:

            Single Color LED Strips
            COB LED Strips
            RGB LED Strips
            etc.

            will open the linked
            Shopify Collection page.
          */

        }
      );



      /* =====================================================
         INITIAL STATE
      ====================================================== */

      if (
        categories.length > 0
      ) {

        const firstCategory =
          categories[0];


        const target =
          firstCategory.getAttribute(
            'data-ls8-category'
          );


        if (target) {

          activateCategory(
            target
          );

        }

      }

    });

  }



  /* =========================================================
     CLICK OUTSIDE PINNED MENU
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      if (!pinnedParent) {

        return;

      }


      /*
        Click inside pinned menu:
        keep menu open
      */

      if (
        pinnedParent.contains(
          event.target
        )
      ) {

        return;

      }


      unpinCurrentMenu(true);

    }
  );



  /* =========================================================
     ESCAPE KEY
  ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        pinnedParent
      ) {

        unpinCurrentMenu(true);

      }

    }
  );



  /* =========================================================
     WINDOW RESIZE

     Pin behavior only used on desktop.
  ========================================================= */

  window.addEventListener(
    'resize',
    function () {

      if (
        window.innerWidth <= 989 &&
        pinnedParent
      ) {

        unpinCurrentMenu(true);

      }

    }
  );



  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initialize(root) {

    initTopLevelMenus(root);

    initLS8MegaMenu(root);

  }



  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initialize(
          document
        );

      }
    );

  } else {

    initialize(
      document
    );

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initialize(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initialize(
        event.target
      );

    }
  );

})();